import { z } from 'zod';
import { User } from '../commentLikeApi/commentLikeApi.types';

// 子コメント情報の型定義
export const ChildCommentSchema = z.object({
  id: z.number(),
  comment_id: z.number(),
  user_id: z.number(),
  content: z.string(),
  created_at: z.string(),
  updated_at: z.string().nullable().optional(),
  deleted_at: z.string().nullable().optional(),
  user: z.object({
    id: z.number().or(z.string()),
    name: z.string(),
    icon_path: z.string().nullable().optional()
  }).optional()
});

export type ChildComment = z.infer<typeof ChildCommentSchema>;

// 子コメント一覧取得リクエスト
export interface FetchChildCommentsRequest {
  comment_id: number | string;
  page?: number;
  limit?: number;
}

// 子コメント一覧取得レスポンス
export const FetchChildCommentsResponseSchema = z.object({
  childComments: z.array(ChildCommentSchema)
});

export type FetchChildCommentsResponse = z.infer<typeof FetchChildCommentsResponseSchema>;

// 子コメント作成リクエスト
export interface CreateChildCommentRequest {
  comment_id: number | string;
  content: string;
}

// 子コメント作成レスポンス
export const CreateChildCommentResponseSchema = z.object({
  childComment: ChildCommentSchema,
  message: z.string().optional()
});

export type CreateChildCommentResponse = z.infer<typeof CreateChildCommentResponseSchema>;

// 子コメント更新リクエスト
export interface UpdateChildCommentRequest {
  content: string;
}

// 子コメント更新レスポンス
export const UpdateChildCommentResponseSchema = z.object({
  childComment: ChildCommentSchema,
  message: z.string().optional()
});

export type UpdateChildCommentResponse = z.infer<typeof UpdateChildCommentResponseSchema>;

// 子コメント削除レスポンス
export const DeleteChildCommentResponseSchema = z.object({
  success: z.boolean().optional(),
  message: z.string().optional()
});

export type DeleteChildCommentResponse = z.infer<typeof DeleteChildCommentResponseSchema>; 